import React from "react";

import useGetViewer from "../graphql/hooks/queries/useGetViewer";
import useGetCredential from "../graphql/hooks/queries/useGetCredential";

import { ViewerContext } from "../hooks/useViewer";

const ViewerProvider = ({ children }) => {
  const { loading, data } = useGetViewer();
  const { data: credentialData } = useGetCredential();
  const credential = credentialData?.credential;

  return (
    <ViewerContext.Provider value={credential ? data?.viewer : null}>
      {loading ? null : children}
    </ViewerContext.Provider>
  );
};

export default ViewerProvider;
